module.exports = __webpack_public_path__ + "img/clock-fast.d32d9ad5.svg";